module.exports = __webpack_public_path__ + "static/media/banner.d7e47dee.jpg";